import type { SVGProps } from 'react';
const SvgExposure = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#exposure_svg__a)">
      <path
        fill="currentColor"
        d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2ZM6 7h5v1.5H6V7Zm13 12H5L19 5v14Zm-4.5-3v2H16v-2h2v-1.5h-2v-2h-1.5v2h-2V16h2Z"
      />
    </g>
    <defs>
      <clipPath id="exposure_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgExposure;
